export default __webpack_public_path__ + "static/media/114-british-virgin-islands.726f930e.svg";